import { makeStyles, mergeClasses } from "@fluentui/react-components";
import * as React from "react";

export type RowProps = React.HTMLAttributes<HTMLDivElement> & {
  noGutter?: boolean;
  isMetaOsV2?: boolean;
  isMetaOsV2HomePage?: boolean;
  isHeroCard?: boolean;
};

const useStyles = makeStyles({
  row: {
    display: "flex",
    flexWrap: "wrap",
    marginRight: "-0.75rem",
    marginLeft: "-0.75rem",
  },

  rowMetaOsV2: {
    maxWidth: "calc(100vw - 390px)",
    "@media (max-width: 719px) and (min-width: 0)": {
      minWidth: "719px",
    },
    columnGap: "16px",
  },

  fixedGridDisplay: {
    display: "grid",
    "@media (min-width: 1500px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    "@media (max-width: 1499px) and (min-width: 960px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 959px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  },

  responsiveGridDisplay: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
  },

  noGutter: {
    marginLeft: "0px",
    marginRight: "0px",
  },
});

export const Row: React.FC<RowProps> = (props) => {
  const styles = useStyles();
  const getStyles = () => {
    if (props.isMetaOsV2) {
      return mergeClasses(
        styles.rowMetaOsV2,
        !props.isHeroCard &&
          (props.isMetaOsV2HomePage
            ? styles.fixedGridDisplay
            : styles.responsiveGridDisplay),
        props.className
      );
    } else {
      return mergeClasses(
        styles.row,
        props.noGutter && styles.noGutter,
        props.className
      );
    }
  };

  return (
    <div {...props} className={getStyles()}>
      {props.children}
    </div>
  );
};
